export { default } from "./FormControlLabel.js";
export { default as formControlLabelClasses } from "./formControlLabelClasses.js";
export * from "./formControlLabelClasses.js";